import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

const categoryIcons: Record<string, string> = {
  all: 'ri-global-line',
  romance: 'ri-heart-line',
  drama: 'ri-movie-line',
  mystery: 'ri-search-eye-line',
  fantasy: 'ri-magic-line',
  urban: 'ri-building-line',
};

export default function CategorySection() {
  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            分类浏览
          </h2>
          <p className="text-sm text-foreground-500 mt-1">多种类型韩漫，总有一款适合你</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={cat.slug === 'all' ? '/category/all' : `/category/${cat.slug}`}
              className="flex flex-col items-center gap-3 p-5 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-200 cursor-pointer group"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-secondary-100 group-hover:bg-primary-100 transition-colors duration-200">
                <i className={`${categoryIcons[cat.slug] || 'ri-folder-line'} text-xl text-secondary-600 group-hover:text-primary-600 transition-colors duration-200`}></i>
              </div>
              <span className="text-sm font-heading font-semibold text-foreground-800 whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-400">{cat.count}部</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}